module.exports = __webpack_public_path__ + "img/code_switch.a92c5c2b.png";